<button (click)="handleClick()" [class.selected]="selected" [ngClass]="buttonVariantClass" class="competency-button">
    <div class="label-container">
        <span class="label-container">
            <app-status-icon [value]="value"></app-status-icon>
            <span class="label">{{label}}</span>
        </span>
        <span *ngIf="aiSuggested" class="ai-suggested label-container">
            <mat-icon class="ai-icon" fontIcon="auto_awesome"></mat-icon>
            <span class="ai-suggested-label">AI Suggested</span>
        </span>
    </div>
    <div [innerHTML]="description" class="description">
    </div>
</button>